import axios from "axios";
import {buildQuery} from "utils/queryUtils";

export const findCountries = (headers, params) => {
    let query = buildQuery(params, ["code", "name"]);
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/countries${query}`, {
        headers
    })
}

export const countCountries = (headers, params) => {
    let query = buildQuery(params);
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/countries/count${query}`, {
        headers
    })
}

export const findCountryById = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/countries/${id}`, {
        headers
    })
}
